import script from "./leftPie1.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie1.vue?vue&type=script&setup=true&lang=js"

import "./leftPie1.vue?vue&type=style&index=0&id=727350d1&scoped=true&lang=css"
script.__scopeId = "data-v-727350d1"

export default script